import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getCompanyById } from '../features/lobby/lobbySlice';
import CompanyLobbyists from '../components/CompanyLobbyists';
import MainLoader from '../components/Structures/MainLoader';

const Company = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { isLoading, company } = useSelector((state) => state.lobby);
  const [totalLobbyists, setTotalLobbyists] = useState(0);
  const [totalSalaryLow, setTotalSalaryLow] = useState(0);
  const [totalSalaryHigh, setTotalSalaryHigh] = useState(0);

  useEffect(() => {
    dispatch(getCompanyById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (company && company.lobbyists) {
      setTotalLobbyists(company.lobbyists.length);

      // Calculate total salary ranges from all lobbyists
      let lowSum = 0;
      let highSum = 0;

      company.lobbyists.forEach((lobbyist) => {
        // Convert string values to numbers and handle potential invalid values
        const salaryLow = parseFloat(lobbyist.SalaryLow) || 0;
        const salaryHigh = parseFloat(lobbyist.SalaryHigh) || 0;

        lowSum += salaryLow;
        highSum += salaryHigh;
      });

      setTotalSalaryLow(lowSum);
      setTotalSalaryHigh(highSum);
    }
  }, [company]);

  if (isLoading) return <MainLoader />;

  return (
    <>
      <div className="bg-[#F9FAFB] border border-[#E5E7EB] 2xl:p-8 xl:p-6 p-5 mb-[20px]">
        <div className="border-b border-[#E5E7EB] mb-8 pb-8">
          {company && company.CompanyName ? (
            <h2 className="font-playfair text-[28px] text-darkblue font-medium leading-8">{company.CompanyName}</h2>
          ) : (
            <h2 className="font-playfair text-[28px] text-darkblue font-medium leading-8">No Company Found.</h2>
          )}
        </div>
        <div className="flex lg:flex-row flex-col items-center lg:justify-start justify-center gap-12">
          <div className="block flex-1">
            {/* Display calculated total spend from lobbyist salaries */}
            <h3 className="lg:text-left text-center text-[22px] font-medium font-playfair mb-5">
              Total Lobbying Spend: ${totalSalaryLow.toLocaleString()} to ${totalSalaryHigh.toLocaleString()}
            </h3>
            <h3 className="lg:text-left text-center text-[22px] font-medium font-playfair mb-5">
              Total Lobbyists: {totalLobbyists}
            </h3>
            <div className="relative">
              {company &&
                (company.CompanyStreet1 || company.CompanyCity || company.CompanyState || company.CompanyZip) && (
                  <h4 className="lg:text-left text-center text-black text-[22px] font-medium font-playfair">
                    {[
                      company.CompanyStreet1,
                      company.CompanyCity,
                      company.CompanyState && company.CompanyZip
                        ? `${company.CompanyState} ${company.CompanyZip}`
                        : company.CompanyState || company.CompanyZip,
                    ]
                      .filter(Boolean)
                      .join(', ')}
                  </h4>
                )}
            </div>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col items-center lg:justify-start justify-center gap-12">
          {company && company.FullSum && (
            <div className="block bg-gray-100 shadow-inner border border-gray-300 p-4 rounded">
              <p className="lg:text-left text-center text-[22px] font-medium font-playfair lg:mb-[40px] mb-5">
                {company.FullSum}
              </p>
            </div>
          )}
        </div>
      </div>

      {company && company.lobbyists && <CompanyLobbyists lobbyists={company.lobbyists} />}
    </>
  );
};

export default Company;
